// src/components/AdminControlPanel.tsx
// CLEANED VERSION - Removed Auto-Advance, Time-Scheduling, and Playlists
// Phase 1 Complete - Ready for Production
import { useEffect, useState } from 'react';
const AdminControlPanel = ({ isOpen, onClose, currentYouTubeVideo, currentMediaVideo, userCount, isHost, queueData, featuredMode }) => {
    const [adminWindow, setAdminWindow] = useState(null);
    useEffect(() => {
        if (isOpen && !adminWindow) {
            // Try to get existing window, or create new one
            let existingWindow = window.gridchatAdminPanel;
            // If window doesn't exist or is closed, create a new one
            if (!existingWindow || existingWindow.closed) {
                existingWindow = window.open('about:blank', 'AdminControlPanel_' + Date.now(), 'width=550,height=320,scrollbars=yes,resizable=yes,toolbar=no,location=no,menubar=no');
            }
            if (!existingWindow) {
                console.error('Failed to open admin panel window');
                return;
            }
            // Clear any existing content completely
            existingWindow.document.open();
            existingWindow.document.write('');
            existingWindow.document.close();
            window.gridchatAdminPanel = existingWindow;
            setAdminWindow(existingWindow);
            existingWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Admin Control Panel</title>
            <style>
              * { margin: 0; padding: 0; box-sizing: border-box; }
              
              body {
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%);
                color: white;
                overflow-x: hidden;
                font-size: 13px;
              }

              .panel-header {
                background: rgba(0, 0, 0, 0.3);
                padding: 14px 16px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                text-align: center;
              }

              .panel-title {
                font-size: 17px;
                font-weight: 600;
                color: #a78bfa;
                letter-spacing: 0.5px;
              }

              .panel-section {
                padding: 12px 16px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.05);
              }

              .section-title {
                font-size: 11px;
                color: rgba(255, 255, 255, 0.5);
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-bottom: 8px;
                font-weight: 600;
              }

              /* Controls Grid */
              .controls-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px;
              }

              .control-card {
                background: rgba(255, 255, 255, 0.05);
                border: 1px solid rgba(255, 255, 255, 0.1);
                border-radius: 6px;
                padding: 10px;
              }

              /* Currently Playing */
              .current-content {
                background: rgba(34, 197, 94, 0.1);
                border: 1px solid rgba(34, 197, 94, 0.3);
                border-radius: 6px;
                padding: 10px;
                margin-bottom: 10px;
                font-size: 12px;
              }

              .content-badge {
                display: inline-block;
                padding: 2px 6px;
                border-radius: 3px;
                font-size: 9px;
                font-weight: 600;
                margin-right: 6px;
              }

              .badge-youtube {
                background: rgba(255, 0, 0, 0.3);
                color: #ff6b6b;
              }

              .badge-media {
                background: rgba(59, 130, 246, 0.3);
                color: #60a5fa;
              }

              .badge-live {
                background: rgba(239, 68, 68, 0.3);
                color: #ef4444;
              }

              .queue-empty {
                text-align: center;
                padding: 15px;
                color: rgba(255, 255, 255, 0.4);
                font-size: 11px;
              }

              /* Buttons */
              .btn {
                background: rgba(255, 255, 255, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.2);
                color: white;
                padding: 6px 10px;
                border-radius: 5px;
                font-size: 12px;
                cursor: pointer;
                transition: all 0.2s ease;
                display: inline-flex;
                align-items: center;
                gap: 4px;
              }

              .btn:hover {
                background: rgba(255, 255, 255, 0.15);
                transform: translateY(-1px);
              }

              .btn-primary {
                background: rgba(139, 92, 246, 0.3);
                border-color: rgba(139, 92, 246, 0.5);
              }

              .btn-primary:hover {
                background: rgba(139, 92, 246, 0.4);
              }

              .btn-danger {
                background: rgba(239, 68, 68, 0.3);
                border-color: rgba(239, 68, 68, 0.5);
              }

              .btn-danger:hover {
                background: rgba(239, 68, 68, 0.4);
              }

              .btn-group {
                display: flex;
                gap: 6px;
                flex-wrap: wrap;
              }

              /* Toggle Controls */
              .theme-toggle-container {
                display: flex;
                align-items: center;
                justify-content: space-between;
              }

              .toggle-label {
                font-size: 11px;
                color: rgba(255, 255, 255, 0.9);
                font-weight: 500;
              }

              .toggle-switch {
                position: relative;
                width: 36px;
                height: 18px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 9px;
                cursor: pointer;
                transition: background 0.3s ease;
                flex-shrink: 0;
              }

              .toggle-switch.active {
                background: rgba(139, 92, 246, 0.6);
              }

              .toggle-slider {
                position: absolute;
                top: 2px;
                left: 2px;
                width: 14px;
                height: 14px;
                background: white;
                border-radius: 50%;
                transition: transform 0.3s ease;
                box-shadow: 0 1px 2px rgba(0,0,0,0.2);
              }

              .toggle-switch.active .toggle-slider {
                transform: translateX(18px);
              }

              /* Scrollbar */
              ::-webkit-scrollbar {
                width: 6px;
              }

              ::-webkit-scrollbar-track {
                background: rgba(255, 255, 255, 0.05);
              }

              ::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.2);
                border-radius: 3px;
              }

              ::-webkit-scrollbar-thumb:hover {
                background: rgba(255, 255, 255, 0.3);
              }
            </style>
          </head>
          <body>
            <div class="panel-header">
              <div class="panel-title">Admin Control Panel</div>
            </div>

            <!-- Currently Playing & Controls -->
            <div class="panel-section">
              <div id="current-content"></div>
              <div class="btn-group" style="margin-top: 8px;">
                <button class="btn btn-primary" onclick="handlePlay()">â–¶ï¸ Play</button>
                <button class="btn btn-primary" onclick="handlePause()">â¸ï¸ Pause</button>
                <button class="btn btn-danger" onclick="handleStop()">â¹ï¸ Stop</button>
                <button class="btn btn-danger" onclick="handleSkip()">â­ï¸ Skip</button>
                <button class="btn" onclick="handleShuffleQueue()">ðŸ”€ Shuffle</button>
                <button class="btn btn-danger" onclick="handleClearQueue()">ðŸ—‘ï¸ Clear</button>
              </div>
            </div>

            <!-- Room Controls -->
            <div class="panel-section">
              <div class="controls-grid">
                <!-- Seasonal Theme -->
                <div class="control-card">
                  <div class="theme-toggle-container">
                    <div class="toggle-label">
                      <span id="theme-label">Seasonal Theme: OFF</span>
                    </div>
                    <div class="toggle-switch" id="seasonal-toggle" onclick="handleSeasonalToggle()">
                      <div class="toggle-slider"></div>
                    </div>
                  </div>
                </div>

                <!-- Access Control -->
                <div class="control-card">
                  <div class="theme-toggle-container">
                    <div class="toggle-label">
                      <span id="require-login-label">Guests Allowed: YES</span>
                    </div>
                    <div class="toggle-switch" id="require-login-toggle" onclick="handleRequireLoginToggle()">
                      <div class="toggle-slider"></div>
                    </div>
                  </div>
                </div>

                <!-- Registration Control -->
                <div class="control-card">
                  <div class="theme-toggle-container">
                    <div class="toggle-label">
                      <span id="invite-only-label">Invite-Only: OFF</span>
                    </div>
                    <div class="toggle-switch" id="invite-only-toggle" onclick="handleInviteOnlyToggle()">
                      <div class="toggle-slider"></div>
                    </div>
                  </div>
                </div>

                <!-- Camera Policy -->
                <div class="control-card">
                  <div class="theme-toggle-container">
                    <div class="toggle-label">
                      <span id="cam-required-label">Cams Required: NO</span>
                    </div>
                    <div class="toggle-switch" id="cam-required-toggle" onclick="handleCamRequiredToggle()">
                      <div class="toggle-slider"></div>
                    </div>
                  </div>
                </div>

                <!-- Username Display -->
                <div class="control-card">
                  <div class="theme-toggle-container">
                    <div class="toggle-label">
                      <span id="username-label">Usernames: OFF</span>
                    </div>
                    <div class="toggle-switch" id="username-toggle" onclick="handleUsernameToggle()">
                      <div class="toggle-slider"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <script>
              let currentQueueData = [];
              let currentContent = null;
              let featuredMode = false;
              let seasonalTheme = false;
              let requireLogin = false;
              let inviteOnlyMode = false;
              let cameraRequired = false;
              let showUsernames = false;

              function formatDuration(seconds) {
                if (!seconds || seconds <= 0) return '0:00';
                const mins = Math.floor(seconds / 60);
                const secs = Math.floor(seconds % 60);
                return \`\${mins}:\${secs.toString().padStart(2, '0')}\`;
              }

              function updateCurrentContent() {
                const container = document.getElementById('current-content');
                if (!currentContent) {
                  container.innerHTML = '<div class="queue-empty">Nothing playing</div>';
                  return;
                }

                let badge = '';
                if (currentContent.type === 'youtube') {
                  badge = '<span class="content-badge badge-youtube">YOUTUBE</span>';
                } else if (currentContent.type === 'media') {
                  badge = '<span class="content-badge badge-media">MEDIA</span>';
                } else if (currentContent.type === 'live') {
                  badge = '<span class="content-badge badge-live">LIVE</span>';
                }

                container.innerHTML = \`
                  <div class="current-content">
                    \${badge}\${currentContent.title || currentContent.filename || 'Untitled'}
                  </div>
                \`;
              }

              function updateQueueDisplay() {
                const container = document.getElementById('queue-items');
                const status = document.getElementById('queue-status');
                const count = document.getElementById('queue-count');

                if (!currentQueueData || currentQueueData.length === 0) {
                  container.innerHTML = '<div class="queue-empty">Queue is empty</div>';
                  status.textContent = '0 items';
                  count.textContent = '0';
                  return;
                }

                status.textContent = \`\${currentQueueData.length} items\`;
                count.textContent = currentQueueData.length;

                let html = '';
                currentQueueData.forEach((item, index) => {
                  let badge = '';
                  if (item.type === 'youtube') {
                    badge = '<span class="content-badge badge-youtube">YT</span>';
                  } else if (item.type === 'media') {
                    badge = '<span class="content-badge badge-media">MD</span>';
                  } else if (item.type === 'live') {
                    badge = '<span class="content-badge badge-live">LIVE</span>';
                  }

                  const currentClass = item.isCurrent ? ' current' : '';
                  const playingBadge = item.isCurrent ? ' <span style="color:#10b981;">â–¶ï¸</span>' : '';

                  html += \`
                    <div class="queue-item\${currentClass}">
                      <div class="queue-item-info">
                        <div class="queue-item-title">
                          \${badge}\${item.title || item.filename || 'Untitled'}\${playingBadge}
                        </div>
                        <div class="queue-item-meta">
                          \${item.duration ? formatDuration(item.duration) + ' â€¢ ' : ''}by \${item.addedBy || 'Unknown'}
                        </div>
                      </div>
                      <div class="queue-item-actions">
                        \${!item.isCurrent ? '<button class="queue-action-btn" onclick="handleRemoveItem(' + index + ')" title="Remove">âœ•</button>' : ''}
                      </div>
                    </div>
                  \`;
                });
                container.innerHTML = html;
              }

              function updateStats() {
                const userCountEl = document.getElementById('user-count');
                const participantsEl = document.getElementById('participants-count');
                const featuredStatusEl = document.getElementById('featured-status');

                if (userCountEl && window.opener) {
                  // User count will be updated via postMessage
                }

                if (participantsEl && window.opener) {
                  participantsEl.textContent = document.getElementById('user-count')?.textContent?.replace(' users', '') || '0';
                }

                if (featuredStatusEl) {
                  featuredStatusEl.textContent = featuredMode ? 'On' : 'Off';
                  featuredStatusEl.style.color = featuredMode ? '#10b981' : '#ef4444';
                }
              }

              // Control handlers
              function handlePlay() {
                if (currentContent?.type === 'live') {
                  window.opener?.postMessage({ type: 'stream-play', data: { streamId: currentContent.id } }, '*');
                } else if (currentContent?.type === 'media') {
                  window.opener?.postMessage({ type: 'media-play', data: { filename: currentContent.filename } }, '*');
                } else {
                  window.opener?.postMessage({ type: 'youtube-play' }, '*');
                }
              }

              function handlePause() {
                if (currentContent?.type === 'live') {
                  window.opener?.postMessage({ type: 'stream-pause', data: { streamId: currentContent.id } }, '*');
                } else if (currentContent?.type === 'media') {
                  window.opener?.postMessage({ type: 'media-pause', data: { filename: currentContent.filename } }, '*');
                } else {
                  window.opener?.postMessage({ type: 'youtube-pause' }, '*');
                }
              }

              function handleStop() {
                if (currentContent?.type === 'live') {
                  window.opener?.postMessage({ type: 'stream-stop', data: { streamId: currentContent.id } }, '*');
                } else if (currentContent?.type === 'media') {
                  window.opener?.postMessage({ type: 'media-stop', data: { filename: currentContent.filename } }, '*');
                } else {
                  window.opener?.postMessage({ type: 'youtube-stop' }, '*');
                }
              }

              function handleSkip() {
                window.opener?.postMessage({ type: 'youtube-skip' }, '*');
              }

              function handleShuffleQueue() {
                if (confirm('Shuffle the queue?')) {
                  window.opener?.postMessage({ type: 'shuffle-queue' }, '*');
                }
              }

              function handleClearQueue() {
                if (confirm('Clear the entire queue?')) {
                  window.opener?.postMessage({ type: 'clear-queue' }, '*');
                }
              }

              function handleRemoveItem(index) {
                window.opener?.postMessage({ type: 'remove-queue-item', data: { index } }, '*');
              }

              function handleSeasonalToggle() {
                seasonalTheme = !seasonalTheme;
                const toggle = document.getElementById('seasonal-toggle');
                const label = document.getElementById('theme-label');

                if (seasonalTheme) {
                  toggle.classList.add('active');
                  label.textContent = 'Seasonal Theme: ON';
                } else {
                  toggle.classList.remove('active');
                  label.textContent = 'Seasonal Theme: OFF';
                }

                // Send message to parent window to toggle seasonal theme
                window.opener?.postMessage({
                  type: 'toggle-seasonal-theme',
                  data: { enabled: seasonalTheme }
                }, '*');
              }

              function handleRequireLoginToggle() {
                requireLogin = !requireLogin;
                const toggle = document.getElementById('require-login-toggle');
                const label = document.getElementById('require-login-label');

                if (requireLogin) {
                  toggle.classList.add('active');
                  label.textContent = 'Guests Allowed: NO';
                } else {
                  toggle.classList.remove('active');
                  label.textContent = 'Guests Allowed: YES';
                }

                // Send chat command to toggle requireLogin
                window.opener?.postMessage({
                  type: 'chat-command',
                  data: { command: 'requirelogin', args: [requireLogin ? 'on' : 'off'] }
                }, '*');
              }

              async function handleInviteOnlyToggle() {
                inviteOnlyMode = !inviteOnlyMode;
                const toggle = document.getElementById('invite-only-toggle');
                const label = document.getElementById('invite-only-label');

                if (inviteOnlyMode) {
                  toggle.classList.add('active');
                  label.textContent = 'Invite-Only: ON';
                } else {
                  toggle.classList.remove('active');
                  label.textContent = 'Invite-Only: OFF';
                }

                // Get auth token from localStorage
                const token = window.opener?.localStorage.getItem('authToken');
                if (!token) {
                  alert('You must be logged in as a host to change this setting');
                  // Revert the toggle
                  inviteOnlyMode = !inviteOnlyMode;
                  return;
                }

                try {
                  const response = await fetch('/api/invites/mode', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': \`Bearer \${token}\`
                    },
                    body: JSON.stringify({ enabled: inviteOnlyMode })
                  });

                  if (!response.ok) {
                    const error = await response.json();
                    alert('Failed to update invite-only mode: ' + (error.error || 'Unknown error'));
                    // Revert the toggle
                    inviteOnlyMode = !inviteOnlyMode;
                    if (inviteOnlyMode) {
                      toggle.classList.add('active');
                      label.textContent = 'Invite-Only: ON';
                    } else {
                      toggle.classList.remove('active');
                      label.textContent = 'Invite-Only: OFF';
                    }
                  } else {
                    const data = await response.json();
                    console.log('âœ… Invite-only mode ' + (inviteOnlyMode ? 'ENABLED' : 'DISABLED'));
                  }
                } catch (error) {
                  alert('Error updating invite-only mode: ' + error.message);
                  // Revert the toggle
                  inviteOnlyMode = !inviteOnlyMode;
                  if (inviteOnlyMode) {
                    toggle.classList.add('active');
                    label.textContent = 'Invite-Only: ON';
                  } else {
                    toggle.classList.remove('active');
                    label.textContent = 'Invite-Only: OFF';
                  }
                }
              }

              // Handle Cam Required toggle
              function handleCamRequiredToggle() {
                cameraRequired = !cameraRequired;
                const toggle = document.getElementById('cam-required-toggle');
                const label = document.getElementById('cam-required-label');

                if (cameraRequired) {
                  toggle.classList.add('active');
                  label.textContent = 'Cams Required: YES';
                } else {
                  toggle.classList.remove('active');
                  label.textContent = 'Cams Required: NO';
                }

                // Send message to main window to update room setting
                if (window.opener && !window.opener.closed) {
                  window.opener.postMessage({
                    type: 'update-camera-required',
                    cameraRequired: cameraRequired
                  }, '*');

                  console.log('ðŸ“¹ Camera requirement ' + (cameraRequired ? 'ENABLED' : 'DISABLED'));
                }
              }

              // Handle Username Display toggle
              function handleUsernameToggle() {
                showUsernames = !showUsernames;
                const toggle = document.getElementById('username-toggle');
                const label = document.getElementById('username-label');

                if (showUsernames) {
                  toggle.classList.add('active');
                  label.textContent = 'Usernames: ON';
                } else {
                  toggle.classList.remove('active');
                  label.textContent = 'Usernames: OFF';
                }

                // Send message to main window to toggle usernames
                if (window.opener && !window.opener.closed) {
                  window.opener.postMessage({
                    type: 'toggle-usernames'
                  }, '*');

                  console.log('ðŸ‘¤ Username display ' + (showUsernames ? 'ENABLED' : 'DISABLED'));
                }
              }

              // Message listener
              window.addEventListener('message', (event) => {
                if (event.origin !== window.opener?.location.origin) return;

                const { type, data, queueData: newQueueData, featuredMode: newFeaturedMode, currentStream, cameraRequired: newCameraRequired } = event.data;

                switch(type) {
                  case 'camera-required-update':
                    // Update camera requirement toggle
                    cameraRequired = newCameraRequired !== undefined ? newCameraRequired : data?.cameraRequired;
                    const camToggle = document.getElementById('cam-required-toggle');
                    const camLabel = document.getElementById('cam-required-label');
                    if (cameraRequired) {
                      camToggle?.classList.add('active');
                      if (camLabel) camLabel.textContent = 'Cams Required: YES';
                    } else {
                      camToggle?.classList.remove('active');
                      if (camLabel) camLabel.textContent = 'Cams Required: NO';
                    }
                    console.log('ðŸ“¹ Camera requirement updated from main window:', cameraRequired);
                    break;

                  case 'queue-data-update':
                    currentQueueData = newQueueData || data || [];
                    // Only update currentContent from queue if there's a current item
                    // Otherwise, preserve existing content (might be a stream)
                    const queueContent = currentQueueData.find(item => item.isCurrent);
                    if (queueContent) {
                      currentContent = queueContent;
                    } else if (currentContent?.type !== 'live') {
                      // Clear if no queue item and not a stream
                      currentContent = null;
                    }
                    updateCurrentContent();
                    updateQueueDisplay();
                    updateStats();
                    break;

                  case 'stream-updated':
                    // Update current content with stream info
                    if (currentStream) {
                      currentContent = {
                        type: 'live',
                        id: currentStream.id,
                        title: currentStream.title || 'Live Stream',
                        filename: null
                      };
                    } else {
                      // Stream stopped - clear only if it was a stream
                      if (currentContent?.type === 'live') {
                        currentContent = null;
                      }
                    }
                    updateCurrentContent();
                    break;

                  case 'featured-mode-state-update':
                    featuredMode = newFeaturedMode !== undefined ? newFeaturedMode : data?.featuredMode;
                    updateStats();
                    break;

                  case 'user-count-update':
                    const userCountEl = document.getElementById('user-count');
                    if (userCountEl && data?.userCount !== undefined) {
                      userCountEl.textContent = \`\${data.userCount} users\`;
                    }
                    updateStats();
                    break;

                  case 'username-display-update':
                    // Update username display toggle
                    showUsernames = data?.showUsernames !== undefined ? data.showUsernames : false;
                    const usernameToggle = document.getElementById('username-toggle');
                    const usernameLabel = document.getElementById('username-label');
                    if (showUsernames) {
                      usernameToggle?.classList.add('active');
                      if (usernameLabel) usernameLabel.textContent = 'Usernames: ON';
                    } else {
                      usernameToggle?.classList.remove('active');
                      if (usernameLabel) usernameLabel.textContent = 'Usernames: OFF';
                    }
                    console.log('ðŸ‘¤ Username display updated from main window:', showUsernames);
                    break;
                }
              });

              // Initialize invite-only mode state from API
              async function initializeInviteOnlyMode() {
                try {
                  const response = await fetch('/api/invites/mode');
                  if (response.ok) {
                    const data = await response.json();
                    inviteOnlyMode = data.inviteOnlyMode || false;
                    const toggle = document.getElementById('invite-only-toggle');
                    const label = document.getElementById('invite-only-label');
                    if (inviteOnlyMode) {
                      toggle.classList.add('active');
                      label.textContent = 'Invite-Only: ON';
                    } else {
                      toggle.classList.remove('active');
                      label.textContent = 'Invite-Only: OFF';
                    }
                  }
                } catch (error) {
                  console.error('Failed to fetch invite-only mode:', error);
                }
              }

              // Initialize seasonal theme state from localStorage
              function initializeSeasonalTheme() {
                const saved = window.opener?.localStorage.getItem('gridchat-seasonal-theme');
                seasonalTheme = saved === 'true';
                const toggle = document.getElementById('seasonal-toggle');
                const label = document.getElementById('theme-label');
                if (seasonalTheme) {
                  toggle?.classList.add('active');
                  if (label) label.textContent = 'Seasonal Theme: ON';
                } else {
                  toggle?.classList.remove('active');
                  if (label) label.textContent = 'Seasonal Theme: OFF';
                }
              }

              // Request initial data
              setTimeout(() => {
                window.opener?.postMessage({ type: 'request-queue-data' }, '*');
                window.opener?.postMessage({ type: 'request-stream-data' }, '*');
                window.opener?.postMessage({ type: 'request-camera-required' }, '*');
                initializeInviteOnlyMode();
                initializeSeasonalTheme();
              }, 100);

              // Update stats periodically
              setInterval(updateStats, 1000);
            </script>
          </body>
        </html>
      `);
            existingWindow.document.close();
        }
        return () => {
            if (adminWindow && !adminWindow.closed) {
                adminWindow.close();
            }
            setAdminWindow(null);
            window.gridchatAdminPanel = null;
        };
    }, [isOpen]);
    return null;
};
export default AdminControlPanel;
